import { Controller } from "@hotwired/stimulus"

// Closes a <details> panel on outside click or Escape — the one thing plain
// HTML <details> can't do on its own, needed once the panel becomes a mobile
// bottom sheet that would otherwise only close by re-tapping the (now
// covered) toggle. Scoped to exactly this concern; not merged into any
// other controller.
export default class extends Controller {
  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onKeydown)
  }

  onDocumentClick(event) {
    if (!this.element.open) return
    if (this.element.contains(event.target)) return
    this.element.open = false
  }

  onKeydown(event) {
    if (event.key !== "Escape") return
    if (!this.element.open) return
    this.element.open = false
    this.element.querySelector("summary")?.focus()
  }
}
